export default "__VITE_ASSET__M2oaMfFE__"